import { createSlice } from "@reduxjs/toolkit";

export const pageSlice = createSlice({
  name: "page",
  initialState: {
    value: 0,
  },
  reducers: {
    goToPage: (state, action) => {
      
      state.value = action.payload; // should never mutate state -> leads to bugs with refresh
      console.log(state.value);
    },
  },
});

// Action creators are generated for each case reducer function
export const { goToPage } = pageSlice.actions;

export default pageSlice.reducer;
